module.exports = "/images/vendor/flag-icon-css/flags/1x1/gt.svg?d6b5b664755ae293fefaab4511db8b9b";